module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/16-5012495d036f6ac588b9913a7f9f367c.png";